import { render, staticRenderFns } from "./Novidade.vue?vue&type=template&id=ced8fcb2&scoped=true&"
import script from "./Novidade.vue?vue&type=script&lang=js&"
export * from "./Novidade.vue?vue&type=script&lang=js&"
import style0 from "./Novidade.vue?vue&type=style&index=0&id=ced8fcb2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ced8fcb2",
  null
  
)

export default component.exports